
<ng-container *ngIf="hasMultipleLinks">
  <ul *ngIf="visibleElements" [ngClass]="listClass">
    <li *ngFor="let elementValue of visibleElements" [ngClass]="'depth-'+elementValue.depth">
      <app-entity-adb-element [value]="elementValue" [range]="adbId" [elementId]="elementValue.element_id" [externalElement]="fieldIsExternal" [trueLink]="trueLink"></app-entity-adb-element>
    </li>
  </ul>
</ng-container>

<ng-container *ngIf="!hasMultipleLinks">
  <ng-container *ngFor="let elementValue of visibleElements">
    <app-entity-adb-element [value]="elementValue" [range]="adbId" [elementId]="elementValue.element_id" [externalElement]="fieldIsExternal" [trueLink]="trueLink"></app-entity-adb-element>
  </ng-container>
</ng-container>